import { Configuration, LogLevel } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.NEXT_PUBLIC_ENTRA_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${process.env.NEXT_PUBLIC_ENTRA_TENANT_ID || '1f991ab0-af89-4a9a-b74d-b0b5bcb487cc'}`,
    redirectUri: typeof window !== 'undefined' ? window.location.origin : '',
    postLogoutRedirectUri: typeof window !== 'undefined' ? window.location.origin : '',
    // Default MSAL behaviour after a successful redirect is to navigate the
    // browser back to whatever URL initiated the loginRedirect (i.e. /login).
    // That puts the user right back on the login page even though auth
    // succeeded. Disable so MSAL lands on redirectUri (= origin = '/') and
    // stops there, letting AuthGuard route them onwards.
    navigateToLoginRequestUrl: false,
  },
  cache: {
    // localStorage persists tokens across tabs and reloads — avoids the full
    // Entra redirect on every new tab and lets silent renew hit the cache
    // instead of opening an iframe.
    cacheLocation: 'localStorage',
    // Cookie fallback for Safari ITP and third-party cookie blocking, which
    // otherwise break the hidden-iframe silent renew.
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
    },
  },
};

export const loginRequest = {
  scopes: [`api://${process.env.NEXT_PUBLIC_ENTRA_CLIENT_ID || ''}/access_as_user`],
};

export const apiScopes = {
  scopes: [`api://${process.env.NEXT_PUBLIC_ENTRA_CLIENT_ID || ''}/access_as_user`],
};
